import { Button as BSButton, Modal } from 'react-bootstrap';
import { userHasPermissionToViewAnyProject } from '../../../helpers/permissions';
import { Team } from '../../../types';
import SelectTeam from '../SelectTeam';

type ModalTeamAssignmentProps = {
  show: boolean;
  onHide: Function;
  allTeams: Team[];
  selectedTeams: Team[];
  onTeamsSelected: (teams: Team[]) => void;
  onTeamsSelectionImport: () => void;
}

const ModalTeamAssignment = (props: ModalTeamAssignmentProps) => (
  <Modal show={props.show} onHide={props.onHide}>
    <Modal.Header>
      <Modal.Title>
        Assign Project to Teams
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <SelectTeam
        allTeams={props.allTeams}
        selectedTeams={props.selectedTeams}
        onTeamsSelected={props.onTeamsSelected}
        permissionKind="project"
      />
    </Modal.Body>
    <Modal.Footer>
      <BSButton onClick={props.onHide}>Cancel</BSButton>
      <BSButton
        onClick={props.onTeamsSelectionImport}
        bsStyle="success"
        disabled={!userHasPermissionToViewAnyProject() && props.selectedTeams.length === 0}
      >
        Import Projects
      </BSButton>
    </Modal.Footer>
  </Modal>
);

export default ModalTeamAssignment;
